module.exports = __webpack_public_path__ + "img/homepage.2fc25fe8.png";